import { T } from 'react-translator-component';

const DASH = '—';

/**
 * Value for the "previous version" column. When a component did NOT change in the
 * event (no previous value) we repeat the current version instead of showing a dash
 * — except on baseline rows ("initial version"), where the dash is correct.
 */
export const previousVersion = (
  ev: any,
  oldV?: string,
  newV?: string,
): string | undefined => (!ev?.baseline && !oldV ? newV : oldV);

/** Renders a version pill, a "restart required" badge, or a dash. */
export const versionCell = (value?: string, needsRestart?: boolean) => {
  if (needsRestart || value === 'RESTART') {
    return <span className='restart-msg'>⟲ {T('Restart')}</span>;
  }
  if (!value) return <span className='version-dash'>{DASH}</span>;
  return <span className='version-tag'>{value}</span>;
};

/** Two-letter initials for the user chip. */
export const initials = (name?: string): string => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const isRemoteUpdate = (ev: any): boolean =>
  ev?.updatedBy?.type !== 'user';

export const updatedByName = (ev: any): string =>
  ev?.updatedBy?.name || ev?.updatedBy?.email || T('Remote update');

export { DASH };
